import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import CustomSelect from '../../ui/CustomSelect';

const leaveTypeOptions = [
  { value: 'annual', label: 'Cuti Tahunan' },
  { value: 'sick', label: 'Sakit' },
  { value: 'maternity', label: 'Cuti Melahirkan' },
  { value: 'paternity', label: 'Cuti Ayah' },
  { value: 'unpaid', label: 'Tanpa Gaji' },
  { value: 'other', label: 'Lainnya' },
];

export default function LeaveModal({ open, form, setForm, employees, saving, onClose, onSave }) {
  if (!open) return null;

  const employeeOptions = [
    { value: '', label: 'Pilih pegawai' },
    ...employees.map(emp => ({ value: emp.id, label: emp.full_name })),
  ];

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-lg w-full max-w-lg max-h-[90vh] overflow-hidden animate-modal">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold">Ajukan Cuti</h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 space-y-3 max-h-[60vh] overflow-y-auto">
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">
              Pegawai <span className="text-red-500">*</span>
            </label>
            <CustomSelect
              value={form.employee_id}
              onChange={val => setForm({ ...form, employee_id: val })}
              options={employeeOptions}
              placeholder="Pilih pegawai"
              width="w-full"
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">
              Jenis Cuti <span className="text-red-500">*</span>
            </label>
            <CustomSelect
              value={form.leave_type}
              onChange={val => setForm({ ...form, leave_type: val })}
              options={leaveTypeOptions}
              placeholder="Pilih jenis cuti"
              width="w-full"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Tanggal Mulai <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                value={form.start_date}
                onChange={e => setForm({ ...form, start_date: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Tanggal Selesai <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                value={form.end_date}
                onChange={e => setForm({ ...form, end_date: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">Alasan</label>
            <textarea
              value={form.reason}
              onChange={e => setForm({ ...form, reason: e.target.value })}
              placeholder="Jelaskan alasan cuti..."
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 resize-none"
            />
          </div>
        </div>
        <div className="flex justify-end gap-3 p-4 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100 font-medium"
          >
            Batal
          </button>
          <button
            onClick={onSave}
            disabled={saving || !form.employee_id || !form.start_date || !form.end_date}
            className="px-4 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 disabled:opacity-50 font-medium"
          >
            {saving ? 'Menyimpan...' : 'Ajukan'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
